<template>
  <div class="mt-2">
    <div class="row">
      <div class="col-md-6">
        <v-card>
          <v-card-title class="headline">
            Código de Seguridad
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="reset"
                @keydown="form.onKeydown($event)"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-textarea
                      v-model="form.qr_code"
                      required
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
              <v-btn
              v-if="!eliminar"
              color="success darken-1"
              text
              :disabled="disabled"
              @click.prevent="openModalStatusCode()"
            >
              Aceptar
            </v-btn>

              <v-btn
              v-if="eliminar"
              color="error darken-1"
              text
              :disabled="disabled"
              @click.prevent="openModalStatusCode()"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <v-dialog
        v-model="dialogStatusCode"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres {{ mensaje }} el código de seguridad?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatusCode = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="loadingCode"
              @click.prevent="save()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Form from 'vform';

export default {
  middleware: 'auth',
  props: {
    id: { default: null },
  },
  data: () => ({
    form: new Form({
      qr_code: '',
    }),
    form2: new Form({
      valor: '',
    }),
    eliminar: false,
    mensaje: 'actualizar',
    switch: false, // MODO PAC
    modo: '',
    activo: '',
    disabled: false,
    toggleStatus: false,
    dialogStatusCode: false,
    loadingCode: false,
    loadingDelivery: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
    apiURLBase: '/api/enterprises',
  }),
  computed: {
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
  },
  async mounted() {
      // Codigo de seguridad
      window.axios.get(`${this.apiURLBase}/${this.enterprise.id}/others/code/edit`)
      .then((result) => {
        // if (result.data.qr_code != null) {
        //   this.mensaje = 'eliminar';
        //   this.eliminar = true;
        // } else {
        //   this.mensaje = 'actualizar';
        // }
        // Object.assign(this.form, result.data);
        // if (this.form.qr_code === '') {
        //   this.disabled = true;
        // }
        if (result.data.qr_security_code != null) {
          this.mensaje = 'eliminar';
          this.eliminar = true;
        } else {
          this.mensaje = 'actualizar';
        }
        this.form.qr_code = result.data.qr_security_code;
        this.URL = `${this.apiURLBase}/${this.enterprise.id}/others/code/update`;
        this.method = 'PUT';
      });
  },
  methods: {
    openModalStatusCode() {
      this.dialogStatusCode = true;
    },
    openModalStatusDelivery() {
        this.dialogStatusDelivery = true;
    },
    store() {
      this.loadingCode = true;
      window.axios({
        method: this.method,
        url: this.URL,
        data: this.form,
      })
      .then(() => {
        this.loadingCode = false;
        this.dialogStatusCode = false;
        this.dialogStatusDelivery = false;

      window.axios.get(`${this.apiURLBase}/${this.enterprise.id}/others/code/edit`)
      .then((result) => {
        if (result.data.qr_security_code != null) {
          this.mensaje = 'eliminar';
          this.eliminar = true;
        } else {
          this.mensaje = 'actualizar';
          this.eliminar = false;
        }
        this.form.qr_code = result.data.qr_security_code;
      });
      }).catch(() => {
        this.loadingCode = false;
        this.dialogStatusCode = false;
        this.dialogStatusDelivery = false;
      });
    },
    save() {
      this.validate(); // someValue
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        if (this.eliminar) {
          this.form.qr_code = '';
        }
        this.store();
      }
    },
  },
};
</script>
